import React, {Component} from 'react';
import {connect} from 'react-redux';
import CodeInput from "../../components/summary/CodeInput";
import {queryVerifyPinCode, queryVerifySuccess} from "../../actions/Recommend";
import {CART_PINCODE_VERIFY_FAILURE, CART_PINCODE_VERIFY_RESPONSE} from "../../constants/ActionTypes";
import clsx from "clsx";
import {selectCartProperty} from "../../actions/Properties";

function mapStateToProps(state) {
    return {
        test: "123"
    };
}

function mapDispatchToProps(dispatch) {
    return {
        verifyPinCode: (pinCode) => {
            return dispatch(queryVerifyPinCode(pinCode));
        },
        verificationComplete: () => {
            return dispatch(queryVerifySuccess());
        },
        selectPinCode: (code) => {
            dispatch(selectCartProperty("pinCode", code));
        }
    };
}

class PinCodeInput extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pinCodeSuccess: false,
            pinCodeError: false
        }

        this.pinCode = false;
        this.latestChangedId = false;

    }

    verifyCode() {


        this.props.verifyPinCode(this.pinCode).then(action => {

            if (action.type === CART_PINCODE_VERIFY_FAILURE) {

                this.setState({
                    pinCodeSuccess: false,
                    pinCodeError: true
                })

            } else if (action.type === CART_PINCODE_VERIFY_RESPONSE && action.response) {

                if (action.response === 404) {

                    this.setState({
                        pinCodeSuccess: false,
                        pinCodeError: true
                    })

                } else if (action.response === 200) {

                    this.props.selectPinCode(this.pinCode);

                    this.setState({
                        pinCodeSuccess: true,
                        pinCodeError: false
                    })

                    setTimeout(() => {
                        this.props.verificationComplete();
                    }, 1250);

                } else {

                    this.setState({
                        pinCodeSuccess: false,
                        pinCodeError: true
                    })

                }
            }

        });

    }

    handleBlur() {
        if (this.pinCode && this.pinCode.length === 6 && this.latestChangedId !== "5") {
            this.verifyCode();
        }
    }

    handleInputChange(fullValue, id) {

        this.pinCode = fullValue;
        this.latestChangedId = id;

        if (fullValue.length === 6 && id === "5") {
            this.verifyCode();
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }

    }

    render() {
        return (
            <div className={clsx("pin-code-input", this.state.pinCodeError && "pin-code-input--error", this.state.pinCodeSuccess && "pin-code-input--success")}>
                <p>Bitte geben Sie die zugehörige PIN ein:</p>
                <CodeInput
                    type={"number"}
                    disabled={this.state.pinCodeSuccess}
                    fields={6}
                    style={{}}
                    inputStyle={{display: "block"}}
                    inputStyleInvalid={{display: "block"}}
                    onChange={(fullValue, id) => {
                        this.handleInputChange(fullValue, id)
                    }}
                    onBlur={(fullValue, id) => {
                        this.handleBlur(fullValue, id)
                    }}
                />
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PinCodeInput);


/** WEBPACK FOOTER **
 ** ./src/containers/outsourcing/PinCodeInput.js
 **/